export default __webpack_public_path__ + "static/media/fa-solid-900.230d39e8.woff";